import React from "react";
import clsx from "clsx";

const Container = ({ children, className }) => {
    return (
        <div
            className={clsx(
                "grid grid-cols-8 sm:grid-cols-12",
                "gap-x-4 sm:gap-x-6 lg:gap-x-8",
                "px-4 sm:px-0",
                "mx-auto",
                className,
                "max-w-1800px"
            )}
        >
            <div className="col-span-12 col-start-1 sm:col-start-2 col-end-12">
                {children}
            </div>
        </div>
    );
};

export default Container;